











































import {
  defineComponent,
  useContext,
  computed,
  watch,
  ref
} from '@nuxtjs/composition-api';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { useCart } from '@wemade-vsf/customer';
import { required, min } from 'vee-validate/dist/rules';
import { SfInput, SfHeading } from '@storefront-ui/vue';
import type { CustomerOrderFields } from '@wemade-vsf/magento-api';

extend('required', {
  ...required,
  message: 'This field is required'
});

extend('min', {
  ...min,
  message: 'The field should have at least {length} characters',
});

export default defineComponent({
  name: 'Comments',
  components: {
    SfHeading,
    SfInput,
    ValidationProvider,
    ValidationObserver
  },
  setup () {
    const { app } = useContext();

    const refConfig = app.$wm.checkout.customOrderFields?.customer_ref || { show: true, required: false };
    const orderNoConfig = app.$wm.checkout.customOrderFields?.customer_order_no || { show: true, required: false };

    const { cart, loading: cartLoading, addCustomOrderFields } = useCart();
    const orderFields = computed(() => cart.value?.wm_customer_order_fields ?? {
      customer_order_no: '',
      customer_ref: ''
    });
    const formCopy = ref<CustomerOrderFields>({
      customer_order_no: orderFields.value.customer_order_no,
      customer_ref: orderFields.value.customer_ref
    });

    watch(() => orderFields.value, (newVal) => {
      formCopy.value = {
        customer_order_no: orderFields.value.customer_order_no,
        customer_ref: orderFields.value.customer_ref
      };
    });

    const onSubmit = async () => {
      await addCustomOrderFields(formCopy.value);
    };

    return {
      cartLoading,
      refConfig,
      orderNoConfig,
      formCopy,
      onSubmit
    };
  }
});
